
export default {
  data: () => ({
    imageUrl: process.env.IMAGE_URL,
  }),
}
